import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { CircularProgress, LinearProgress } from "@material-ui/core";
import { styled } from "../styled";
import { theme as themeStyle } from "../theme";

const useStyles = makeStyles((theme) => ({
	colorPrimary: {
		position: "absolute",
		top: "50%",
		left: "50%",
		height: 20,
		margin: "0 auto",
		color: "#FFF",
		border: `5px solid ${themeStyle.colors.mainGreen.main}`,
		borderRadius: 50,
		variant: "indeterminate",
		background: "transparent",
		"& .MuiCircularProgress-colorPrimary": {
			backgroundColor: "#006E2D",
		},
		"& .MuiCircularProgress-barColorPrimary": {
			backgroundColor: "#006E2D",
		},
	},
	text: {
		margin: "0 auto",
	},
}));

const FloatingContainer = styled("div")({
	position: "absolute",
	top: 0,
	left: 0,
	right: 0,
	bottom: 0,
	backgroundColor: "rgba(0, 0, 0, 0.85)",
	zIndex: 9999,
});

const SpLoader = () => {
	const classes = useStyles();

	return (
		<FloatingContainer>
			<CircularProgress size={100} className={classes.colorPrimary} />
		</FloatingContainer>
	);
	// return (<SpText variant={'h4ComponentLabel'} className={classes.text}>{labels.loading_data}</SpText>);
};

export default SpLoader;
